module.exports = __webpack_public_path__ + "48e1e85248e5bb29b48bc68895a9b361.svg";